<template>
    <v-alert
        border="bottom"
        colored-border
        icon="fas fa-exclamation-triangle"
        elevation="2"
        class="alerttop"
    >
        <p class="mb-0">{{ content5 }}</p>
        <p class="mb-0" v-html="content6"></p>
    </v-alert>
</template>

<script>
import { mapState } from 'vuex';
import { VAlert } from 'vuetify/lib';

export default {
    components: { VAlert },
    data() {
        return {
            borderAlertColor: "",
            iconAlertColor: "",
            bgAlertColor: ""
        }
    },
    computed: {
        ...mapState({
            content5(state) {
                let email = "";
                if(!state.session.user)
                    this.$store.dispatch("setUserAction");
                else
                    email = state.session.user.email;
                return this.$t("registerEventLegacy.content_5", {email})
            },
            urlProfile(state) {
                return `${state.env.get('VUE_APP_BASE')}profile`
            }
        }),
        content6() {
            return this.$t('registerEventLegacy.content_6', { link: this.urlProfile })
        }
    },
    created() {
        this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');    
        this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');    
        this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');   
    },
    mounted() {
        document.querySelectorAll(".alerttop").forEach(x => { x.setAttribute("style", "background:"+this.bgAlertColor); });
        document.querySelectorAll(".v-alert__icon").forEach( x => { x.setAttribute("style", "color: "+this.iconAlertColor)});
        document.querySelectorAll(".v-alert__border").forEach( x => { x.setAttribute("style", "color: "+this.borderAlertColor)});  
    }
}
</script>